import styled from 'styled-components';
import { fontTitle, fontBody } from 'Styles/fonts';
import { black, red } from 'Styles/colors';
import breakpoint from 'Styles/breakpoints';

import ButtonIcon from '../Icons/ButtonIcon';
import Button from '../Button/Button';
import { CardContent as CardContentOriginal } from '../Card/Card';

export const CardContent = styled(CardContentOriginal)`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const UpsellContent = styled.div`
  flex: 1;
  margin-left: 16px;
`;

export const Title = styled.h1`
  ${fontTitle(14)};
  color: ${black};
  margin: 0;

  ${breakpoint('medium')} {
    ${fontTitle(16)};
  }
`;

export const Subtitle = styled.p`
  ${fontBody(14)};
  color: ${black};
  margin: 0;

  ${breakpoint('medium')} {
    ${fontBody(16)};
  }
`;

export const Price = styled.p`
  ${fontBody(14)};
  color: ${black};
  margin: 0;

  ${breakpoint('medium')} {
    ${fontBody(16)};
  }
`;

export const ImageContainer = styled.div`
  width: 150px;
  height: 150px;
`;

export const AddToBagButton = styled(ButtonIcon).attrs({
  variant: 'defaultDark',
  iconPosition: 'left'
})`
  ${fontTitle(16)};
  margin-top: 8px;
`;

export const SoldOutButton = styled(Button)`
  margin-top: 8px;
`;

export const Error = styled.p`
  ${fontBody(14)};
  color: ${red};
  margin: 0;
  margin-top: 8px;
`;
